import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import '../../base/addButton/AddButton.module.scss.js';
import '../../base/alert/Alert.js';
import '../../base/breadcrumb/Breadcrumb.module.scss.js';
import { Button } from '../../base/button/Button.js';
import 'react-aria';
import 'react-stately';
import 'react';
import '../../base/iconButton/IconButton.js';
import '../../base/calendar/Calendar.module.scss.js';
import 'dayjs';
import '../../base/calendar/calendarGrid/CalendarGrid.module.scss.js';
import '../../base/calendar/calendarGrid/calendarCell/CalendarCell.module.scss.js';
import '../../base/carBackground/CarBackground.module.scss.js';
import '../../base/loader/Loader.module.scss.js';
import '../../base/carLoader/CarLoader.module.scss.js';
import { Card } from '../../base/card/Card.js';
import '../../base/confirmation/Confirmation.js';
import '../../base/modal/Modal.js';
import '../../base/confirmationModal/ConfirmationModal.module.scss.js';
import '../../base/error/Error.module.scss.js';
import { FullArrowRightIcon } from '../../icons/FullArrowRightIcon.js';
import '../../base/tag/Tag.module.scss.js';
import '../../base/vehicleQuote/VehicleQuote.module.scss.js';
import '../../base/insuranceQuote/InsuranceQuote.module.scss.js';
import '../../base/listBox/ListBox.js';
import '../../base/listCard/ListCard.js';
import 'react-dom';
import 'react-transition-group';
import '../../base/popover/Popover.module.scss.js';
import '../../base/progressBar/ProgressBar.module.scss.js';
import '../../base/toast/context/ToastContext.js';
import '../../base/toast/Toast.module.scss.js';
import '../../base/toast/context/ToastContext.module.scss.js';
import '../../base/tooltip/Tooltip.module.scss.js';
import styles from './RenewalPayment.module.scss.js';

var RenewalPayment = function (_a) {
    var currentFormattedPrice = _a.currentFormattedPrice, newFormattedPrice = _a.newFormattedPrice, differenceFormattedPrice = _a.differenceFormattedPrice, onDecline = _a.onDecline, onConfirm = _a.onConfirm, className = _a.className, style = _a.style;
    return (jsxs(Card, __assign({ className: className, style: style }, { children: [jsx("p", __assign({ className: styles.title }, { children: "Renewal payment" })), jsx(Card.Separator, { isFullWidth: true }), jsxs("div", __assign({ className: styles.pricesSummary }, { children: [jsxs("div", __assign({ className: clsx(styles.summaryTile, styles.summaryTileDimmed) }, { children: [jsx("p", { children: "Without any changes" }), jsx("p", __assign({ className: styles.price }, { children: currentFormattedPrice }))] })), jsx(FullArrowRightIcon, { className: styles.icon }), jsxs("div", __assign({ className: clsx(styles.summaryTile, styles.summaryTileRight) }, { children: [jsx("p", { children: "With increased value(s)" }), jsx("p", __assign({ className: styles.price }, { children: newFormattedPrice })), jsxs("p", { children: ["only ", differenceFormattedPrice, " more"] })] }))] })), jsxs("div", __assign({ className: styles.buttons }, { children: [jsx(Button, __assign({ onClick: onConfirm }, { children: "Yes, renew with new value(s)" })), jsx(Button, __assign({ variant: "inverted", onClick: onDecline }, { children: "No, renew with existing value(s)" }))] }))] })));
};

export { RenewalPayment };
